import React, { useEffect, useState }  from 'react'
import './Subscribe.scss'

import catalog from '../../../assets/Pictures/productCatalog.svg'
import newsletter from '../../../assets/Pictures/newsletter.svg'
import longArrow from '../../../assets/Pictures/longArrow.svg'

import 'aos/dist/aos.css'
import Aos from 'aos'

import { Link } from 'react-router-dom'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export default function Subscribe() {
  const [email, setEmail] = useState('')

  useEffect(() => {
    Aos.init({ duration: 2500, once: true })
  }, [])

  const emailHandler = () => {
    if (email.length > 5 && email.includes('@')) {
      toast.success('thank you for join', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    } else {
      toast.error('email address wrong', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='subscribePageAr'>
        <div className="container">
          <div className="row">
            <div className='promotion_parts' data-aos='fade-left'>
              <div className='promotion_newsletter'>
                <div className='left'>
                  <img src={newsletter} alt='newsletter' />
                </div>
                <div className='contents'>
                  <div className='top'>
                    يمكنك التسجيل في قائمة البريد الإلكتروني لدينا لتكون على علم بإعلاناتنا
                  </div>
                  <div className='bottom'>
                    <div className='input'>
                      <input type='email' name='' id='' placeholder='Email Address' onChange={e => setEmail(e.target.value)} />
                    </div>
                    <div className='button'>
                    <div className='button' onClick={emailHandler}>
                      <button>یرسل</button>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='promotion_catalog' data-aos='fade-left'>
                <div className='left'>
                  <img src={catalog} alt='catalog' />
                </div>
                <div className='contents'>
                  <div className='top'>
                    يمكنك مراجعة الكتالوج الخاص بنا وتنزيله على جهاز الكمبيوتر الخاص بك.
                  </div>
                  <div className='bottom'>
                    <div className='text'>
                      رابط التحميل
                    </div>
                    <div className='arrow'>
                      <img src={longArrow} alt='longArrow' />
                    </div>
                    <Link target='_blank' to='https://tfmenu.storage.iran.liara.space/FinalInvestment.pdf' className='button' >
                      تحميل
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
